import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logos/bywe_stacked-logo.svg")